module.exports = __webpack_public_path__ + "img/points-icon.3e7e5d2a.png";